import React from "react";
import CourseLockedBottomSheet from "../CourseLockedBottomSheet/CourseLockedBottomSheet";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";
import { getLockedContentText } from "@src/utils";
import { safeJsonParse } from "@src/utils/safeJsonParse";
const TestIsTemporarilyLockedTimingBottomSheet = () => {
  const { t } = useTranslation();
  const state = useSelector(
    (state) =>
      state?.bottomSheetReducer?.showTestIsTemporarilyLockedTimingBottomSheet
  );
  const testScheduleStartDate = useSelector(
    (state) =>
      state?.bottomSheetReducer
        ?.showTestIsTemporarilyLockedTimingBottomSheetDates?.startDate
  );
  const testScheduleEndDate = useSelector(
    (state) =>
      state?.bottomSheetReducer
        ?.showTestIsTemporarilyLockedTimingBottomSheetDates?.endDate
  );

  const item = safeJsonParse(localStorage.getItem("currentItem"), {
    source: "TestIsTemporarilyLockedTimingBottomSheet [localStorage.currentItem]",
    fallback: {},
  });
  let scheduledFromDateText = item?.scheduledFromDateText;
  let scheduledToDateText = item?.scheduledToDateText;
  let isPurchased = item?.isPurchased;
  let isScheduled = item?.isScheduled;
  let isLocked = item?.isLocked;
  // let showBtn = !isScheduled || (!isPurchased && isLocked) ? 1 : 0;
  let showBtn = isPurchased ? 0 : isLocked;
  // const testScheduleStartDate = `10:00 AM, 23 FebSSSSS`;
  // const testScheduleEndDate = `10:00 AM, 25 FebEEEE`;

  const dispatch = useDispatch();
  return (
    <CourseLockedBottomSheet
      src={getAwsAssets("padlock.svg", "bottomSheets")}
      mainText={t(
        "components.bottomSheets.components.testIsTemporarilyLockedTimingBottomSheet.testIsTemporarilyLocked",
        "Your Content is Locked"
      )}
      subText={getLockedContentText(
        scheduledFromDateText,
        scheduledToDateText,
        isPurchased,
        isScheduled,
        isLocked
      )}
      // subText={t(
      //   "components.bottomSheets.components.testIsTemporarilyLockedTimingBottomSheet.testIsLockedByTutor",
      //   "The test you’re trying to attempt has been locked by your tutor. Please get in touch with your tutor."
      // )}
      // boldSubText={`${testScheduleStartDate} ${t(
      //   "components.bottomSheets.components.testIsTemporarilyLockedTimingBottomSheet.toText",
      //   "to"
      // )} ${testScheduleEndDate}`}
      btnText={t(
        "components.bottomSheets.components.testIsTemporarilyLockedTimingBottomSheet.okay",
        "Okay"
      )}
      btnAction={() =>
        dispatch(
          actionCreator.showTestIsTemporarilyLockedTimingBottomSheetAction(
            false
          )
        )
      }
      state={state}
      viewAllSubText={
        showBtn
          ? t(
              "components.bottomSheets.components.contentLockedBottomSheet.goBackInstead",
              "Go back instead"
            )
          : t(
              "components.bottomSheets.components.contentLockedBottomSheet.goBack",
              "Go back"
            )
      }
      dispatcher={() =>
        dispatch(
          actionCreator.showTestIsTemporarilyLockedTimingBottomSheetAction(
            false
          )
        )
      }
      showBtn={showBtn}
    />
  );
};

export default TestIsTemporarilyLockedTimingBottomSheet;
